<template>
  <div class="my-list-box">
    <section class="c-list-search" v-if="isSearchShow">
      <van-search show-action v-model="searchData.value" :placeholder="placeholderTitle">

        <template #action>
          <van-button v-if="createFunc" type="primary" size="small" @click="createFunc">创建订单</van-button>
          <van-button type="info" size="small" @click="onSearch">搜索</van-button>
        </template>
      </van-search>
    </section>
    <section class="c-list-tabs" v-if="isTabsShow">
      <van-tabs v-model="active" @change="onChangeTab">
        <van-tab v-for="(item, index) in tabList" :key="index" :title="item.title"></van-tab>
      </van-tabs>
    </section>
    <section :class="isTabsShow ? 'c-list c-list-top92' : isSearchShow ? 'c-list c-list-top50' : 'c-list'"
      v-if="isListShow">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <section>
            <div type="spinner" size="24px" class="c-box c-list-box" v-for="(items, index) in list" :key="index">
              <section class="c-content-box">
                <ul class="c-content-ul" v-for="(item, itemIndex) in items.boxLines" :key="itemIndex">
                  <li v-for="(line, lineIndex) in item.rowList" :key="lineIndex"
                    :class="!line.isShow ? 'c-display-none' : ''">
                    <span>{{ line.title }}</span>
                    <i :class="line.className">{{ line.value }}</i>
                  </li>
                </ul>
                <div v-if="isButtonShow" class="c-list-content-button">
                  <van-button @click="onButton(items, item.title)"
                    v-for="(item, index) in getNewButtonList(items, buttonList)" :key="index" round type="info">
                    {{ item.title }}
                  </van-button>
                </div>
              </section>
            </div>
          </section>
        </van-list>
      </van-pull-refresh>
    </section>
  </div>
</template>

<script>
import { FormatDate } from "~/script/utils";

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      active: 0,
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      searchData: {
        value: null,
      },
    };
  },
  props: {
    isSearchShow: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isTabsShow: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isListShow: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isButtonShow: {
      type: Boolean,
      default() {
        return false;
      },
    },
    items: {
      type: Object,
    },
    getList: {
      type: Function,
      default() {
        return null;
      },
    },
    listMap: {
      type: Object,
    },
    placeholderTitle: {
      type: String,
      default() {
        return null;
      },
    },
    tabList: {
      type: Array,
      default() {
        return [];
      },
    },
    buttonList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    // 获取数据
    async getData() {
      const { pagination, searchData } = this;
      const data = await this.getList(pagination, searchData);
      this.pagination.total = data.Total;
      const newList = this.setList(data.List);

      this.list.push(...newList); //将数据放入list中
      this.loading = false; //加载状态结束
      if (this.list.length >= data.Total) {
        this.finished = true; //结束加载状态
      }
    },

    // 设置数据
    setList(list) {
      const newList = [];
      if (list.length == 0) {
        this.finished = true; // 停止加载
        return [];
      }
      list.forEach((item, index) => {
        let initItem = Object.assign({}, item);
        const newItems = this.setRowData(initItem);
        newList.push(newItems);
      });
      return newList;
    },
    setRowData(initItem) {
      let newItems = JSON.parse(JSON.stringify(this.listMap));
      newItems.Id = initItem.Id;
      let boxLines = newItems.boxLines;

      boxLines.forEach((line) => {
        let rowList = line.rowList;
        rowList.forEach((key) => {
          key["isShow"] = true;
          if (key.dataType == "Date") {
            key["value"] = FormatDate(initItem[key.banding], "yyyy-MM-dd");
          } else if (key.dataType == "Type") {
            const dataMap = key["dataMap"];
            key["value"] = dataMap[initItem[key.banding]];
          } else if (key.dataType == "number_show") {
            const value = initItem[key.banding];
            if (!value || value == 0) {
              key["isShow"] = false;
            }
            key["value"] = value;
          } else {
            key["value"] = initItem[key.banding];
          }

          const classMap = key["classMap"];

          if (classMap) {
            const field = key.classNameBinding || key.banding
            //console.error("classMap", classMap, field, initItem[field])
            var css = [key["className"]]
            css.push(classMap[initItem[field]]);
            key["className"] = css.filter(e => e).join(" ")

          }

        });
      });      
      return newItems || [];
    },

    // 加载数据
    onLoad() {
      let timer = setTimeout(() => {
        if (this.refreshing) {
          this.pagination.page = 1; // 分页数加一
          this.list = [];
          this.refreshing = false;
        }
        this.getData(); // 调用上面方法,请求数据
        this.pagination.page++; // 分页数加一
        this.finished && clearTimeout(timer); //清除计时器
      }, 100);
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pagination.page = 1; // 分页数赋值为1
      this.list = []; // 清空数组
      this.onLoad();
    },

    // 搜索
    onSearch() {
      this.pagination.page = 1;
      this.list = []; // 清空数组
      this.onLoad();
    },
    // 切换tab
    onChangeTab() {
      this.pagination.page = 1;
      this.list = []; // 清空数组
      this.$emit("changeTab", this.active);
      this.$router.push({ query: { ...this.$route.query, id: this.active } });
      this.onLoad();
    },
    // 点击按钮
    onButton(items, title) {
      if (title == "编辑") {
        this.$emit("onEdit", items.Id);
      } else {
        this.$emit("onSeeDetail", items);
      }
    },

    getNewButtonList(itmes, buttonList) {
      // console.log(buttonList, itmes.boxLines[5]);
      var row5 = itmes.boxLines[5] || { rowList: [{}] };
      if (row5.rowList[0].value == "已审核") {
        return [{ title: "查看详情" }]
      } else {
        return buttonList
      }
    }
  },
  watch: {

  },
  computed: {
    createFunc() {
      var tab = this.tabList[this.active];
      if (!tab) return null;
      return tab.onCreate;
    },

  },
  created() {
    const id = Number(this.$route.query?.id) ?? 0;
    if (id) this.$emit("changeTab", this.active = id);
  },
};
</script>

<style lang="less" scope>
.my-list-box {
  height: 100%;

  .c-list-search {
    position: fixed;
    top: 46px;
    width: 100%;
    z-index: 1000;

    .van-button+.van-button {
      margin-left: 0.5em;
    }

  }

  .c-list-tabs {
    position: fixed;
    top: 100px;
    width: 100%;
    z-index: 1000;
  }

  .c-list {
    height: 100%;

    .c-list-box {
      width: 98%;
      min-height: 40px;
      background: #fff;
      margin: 8px auto;

      .c-content-box {
        padding: 0;
      }
    }

    .c-list-content-button {
      margin-top: 10px;
      text-align: right;

      .van-button {
        padding: 0;
        width: 65px;
        height: 25px;
        line-height: 25px;
        margin-left: 10px;
        font-size: 0.12rem;
      }
    }

    .van-pull-refresh {
      height: 100%;
    }
  }

  .c-list-top50 {
    margin-top: 50px;
  }

  .c-list-top92 {
    margin-top: 92px;
  }

  .c-list-search-button {
    height: 30px;
    font-size: 0.12rem;
  }

  .c-display-none {
    display: none;
  }

  .c-box {
    &+.c-box {
      border-top: 1px #ccc dotted;
    }
  }
}
</style>
